import { render, staticRenderFns } from "./AppointmentsHeader.vue?vue&type=template&id=2996e6bc&scoped=true"
import script from "./AppointmentsHeader.vue?vue&type=script&lang=js"
export * from "./AppointmentsHeader.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsHeader.vue?vue&type=style&index=0&id=2996e6bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2996e6bc",
  null
  
)

export default component.exports